import { Outlet, useLocation } from 'react-router-dom'
import { useEffect, useRef, useState } from 'react'
import { useMediaQuery } from '../../hooks/useMediaQuery'
import MainLayout from './MainLayout'
import MobileLayout from './MobileLayout'

const PAGES_WITHOUT_SIDEBAR = ['/login', '/register', '/forgot-password', '/reset-password', '/verify-email']

export default function GlobalLayout() {
  const location = useLocation()
  const [forbiddenMessage, setForbiddenMessage] = useState(null)
  const isMobileViewport = useMediaQuery('(max-width: 1023px)')
  const useMobileLayout = isMobileViewport
  const forcedDarkRef = useRef(false)

  useEffect(() => {
    let hideTimeout
    const handler = (e) => {
      const message = e.detail?.message || 'No tienes permisos para esta acción'
      if (hideTimeout) clearTimeout(hideTimeout)
      setForbiddenMessage(message)
      hideTimeout = setTimeout(() => setForbiddenMessage(null), 5000)
    }
    window.addEventListener('api:forbidden', handler)
    return () => {
      window.removeEventListener('api:forbidden', handler)
      if (hideTimeout) clearTimeout(hideTimeout)
    }
  }, [])

  useEffect(() => {
    if (useMobileLayout) {
      document.body.classList.add('mobile-ui')
      document.body.classList.remove('desktop-ui', 'admin-app-ui', 'vet-owner-ui', 'vet-basic-ui')
    } else {
      document.body.classList.add('desktop-ui')
      document.body.classList.remove('mobile-ui', 'admin-app-ui', 'vet-owner-ui', 'vet-basic-ui')
    }

    return () => {
      document.body.classList.remove('mobile-ui', 'desktop-ui', 'admin-app-ui', 'vet-owner-ui', 'vet-basic-ui')
      if (forcedDarkRef.current) {
        document.documentElement.classList.remove('dark')
        forcedDarkRef.current = false
      }
    }
  }, [useMobileLayout])

  if (PAGES_WITHOUT_SIDEBAR.includes(location.pathname)) {
    return <Outlet />
  }

  if (useMobileLayout) {
    return (
      <>
        {forbiddenMessage && (
          <div
            role="alert"
            className="fixed top-0 left-0 right-0 z-[100] bg-amber-500 dark:bg-amber-600 text-gray-900 dark:text-amber-50 text-center py-2 px-4 text-sm font-medium shadow-md"
          >
            {forbiddenMessage}
          </div>
        )}
        <MobileLayout>
          <Outlet />
        </MobileLayout>
      </>
    )
  }

  return (
    <>
      {forbiddenMessage && (
        <div
          role="alert"
          className="fixed top-0 left-0 right-0 z-[100] bg-amber-500 dark:bg-amber-600 text-gray-900 dark:text-amber-50 text-center py-2 px-4 text-sm font-medium shadow-md"
        >
          {forbiddenMessage}
        </div>
      )}
      <MainLayout>
        <Outlet />
      </MainLayout>
    </>
  )
}
